"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.withMediaQuery = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = require("react-responsive");

var _config = require("./config");

var withMediaQuery = function withMediaQuery(component, screen) {
  if (screen === void 0) {
    screen = _config.SCREENS.MOBILE;
  }

  var validScreens = Object.values(_config.SCREENS);

  if (!validScreens.includes(screen)) {
    throw new TypeError("Screens should be one \"" + validScreens.join('|') + "\"");
  }

  return /*#__PURE__*/_react["default"].createElement(_reactResponsive.Context.Provider, {
    value: _config.VIEWPORTS[screen]
  }, component);
}; // eslint-disable-next-line import/prefer-default-export


exports.withMediaQuery = withMediaQuery;